module.exports = __webpack_public_path__ + "img/add_btn_icon121.1359e9c0.svg";